import { isNone } from '@ember/utils';
import window from 'ember-window-mock';

export function outerWidth(element: HTMLElement, withMargin = false) {
  if (isNone(element)) {
    return;
  }

  let width = element.offsetWidth;

  if (withMargin) {
    let style = getComputedStyle(element);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  }

  return width;
}

export function elementContainsTarget(element: Element | null, target: EventTarget | null) {
  if (isNone(element) || isNone(target)) {
    return false;
  }

  return element.contains(target as Node);
}

// https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API#example
interface PageVisibilityExtendedDocument extends Document {
  msHidden?: boolean;
  webkitHidden?: boolean;
}

export function isBrowserWindowVisible() {
  let doc = window.document as PageVisibilityExtendedDocument;

  let hiddenProp: 'hidden' | 'msHidden' | 'webkitHidden' = 'hidden';

  if (typeof doc.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hiddenProp = 'hidden';
  } else if (typeof doc.msHidden !== 'undefined') {
    hiddenProp = 'msHidden';
  } else if (typeof doc.webkitHidden !== 'undefined') {
    hiddenProp = 'webkitHidden';
  }

  return !(doc[hiddenProp] ?? false);
}
